import login from './endpoints/login';
import getUsers from './endpoints/getUsers';
import setPermissions from './endpoints/setPermissions';
import getPayments from './endpoints/getPayments';
import getPromoCodes from './endpoints/getPromoCodes';
import createPromoCode from './endpoints/createPromoCode';
import deletePromoCode from './endpoints/deletePromoCode';
import getUsageStatistics from './endpoints/getUsageStatistics';
import resetPassword from './endpoints/resetPassword';
import anonymizeUser from './endpoints/anonymizeUser';
import setUserInfo from './endpoints/updateUserInfo';
import getAdminNotes from './endpoints/getAdminNotes';
import getAllAdminNotes from './endpoints/getAllAdminNotes';
import addAdminNote from './endpoints/addAdminNote';
import getUserPayments from './endpoints/getUserPayments';
import getAccountConnectInfo from './endpoints/getAccountConnectInfo';
import connectAccount from './endpoints/connectAccount';
import disconnectAccount from './endpoints/disconnectAccount';
import setExpirationDate from './endpoints/setExpirationDate';
import getAuditReport from './endpoints/getAuditReport';
import deleteTerraDevice from './endpoints/deleteTerraDevice';
import getChartReviews from './endpoints/getChartReviews';
import getStudies from './endpoints/getStudies';
import getStudy from './endpoints/getStudy';
import createStudy from './endpoints/createStudy';
import deleteStudy from './endpoints/deleteStudy';
import getStudyParticipants from './endpoints/getStudyParticipants';
import deleteStudyParticipant from './endpoints/deleteStudyParticipant';
import createStudyParticipant from './endpoints/createStudyParticipant';
import getParticipantDocuments from './endpoints/getParticipantDocuments';
import createParticipantDocument from './endpoints/createParticipantDocument';
import deleteParticipantDocument from './endpoints/deleteParticipantDocument';
import getParticipantDocument from './endpoints/getParticipantDocument';
import getCycleAnswers from './endpoints/getCycleAnswers';
import getDateAnswers from './endpoints/getDateAnswers';
import getStudyQuestions from './endpoints/getStudyQuestions';
import addQuestionToStudy from './endpoints/addQuestionToStudy';
import removeQuestionFromStudy from './endpoints/removeQuestionFromStudy';
import getQuestions from './endpoints/getQuestions';
import editStudyParticipant from './endpoints/editStudyParticipant';
import getSlides from './endpoints/getSlides';
import addSlideToStudy from './endpoints/addSlideToStudy';
import removeSlideFromStudy from './endpoints/removeSlideFromStudy';
import getStudySlides from './endpoints/getStudySlides';
import addUser from './endpoints/addUser';
import getParticipantCycles from './endpoints/getParticipantCycles';
import getParticipantCycleData from './endpoints/getParticipantCycleData';
import getAnonymizedDeviceUsers from './endpoints/getAnonymizedDeviceUsers';
import getAnonymizedDeviceUserCharts from './endpoints/getAnonymizedDeviceUserCharts';

const api = {
    login,
    getUsers,
    setPermissions,
    getPayments,
    getPromoCodes,
    createPromoCode,
    deletePromoCode,
    getUsageStatistics,
    resetPassword,
    anonymizeUser,
    setUserInfo,
    getAdminNotes,
    getAllAdminNotes,
    addAdminNote,
    getUserPayments,
    getAccountConnectInfo,
    connectAccount,
    disconnectAccount,
    setExpirationDate,
    getAuditReport,
    deleteTerraDevice,
    getChartReviews,
    getStudies,
    getStudy,
    createStudy,
    deleteStudy,
    getStudyParticipants,
    createStudyParticipant,
    editStudyParticipant,
    deleteStudyParticipant,
    getParticipantDocuments,
    createParticipantDocument,
    deleteParticipantDocument,
    getParticipantDocument,
    getCycleAnswers,
    getDateAnswers,
    getStudyQuestions,
    addQuestionToStudy,
    removeQuestionFromStudy,
    getQuestions,
    getSlides,
    addSlideToStudy,
    removeSlideFromStudy,
    getStudySlides,
    addUser,
    getParticipantCycles,
    getParticipantCycleData,
    getAnonymizedDeviceUsers,
    getAnonymizedDeviceUserCharts,
};

export default api;
